import React from "react";

import { Box, Grid, Typography } from "@mui/material";
import { ptBR } from "date-fns/locale";

export function ChartCaption({ label, color, ...props }: ChartCaptionProps) {
  return (
    <Box sx={{ margin: 1 }}>
      <Grid container direction="row" alignItems="center" gap={0.6}>
        <Typography variant="caption">{label}</Typography>
        {color && (
          <Box
            sx={{
              height: 3,
              width: 15,
              bgcolor: color,
            }}
          />
        )}
      </Grid>
      {"total" in props && (
        <Grid container direction="row" alignItems="baseline" gap={0.6}>
          <Typography variant="body2" component="span">
            {props.total.toLocaleString(ptBR.code)}
          </Typography>
          <Typography variant="caption" component="span">
            {props.unit}
          </Typography>
        </Grid>
      )}
    </Box>
  );
}

export type ChartCaptionProps =
  | {
      label: string;
      color: string;
    }
  | {
      total: number;
      label: string;
      unit: string;
      color?: string;
    };
